// extracted by mini-css-extract-plugin
module.exports = {"leadTitle":"Header_leadTitle__YoGOt","mainLogo":"Header_mainLogo__TKqBG","header":"Header_header__pXml_"};